import { DateTime } from 'luxon';

// Fixed to Argentina so the SSR pass (server in UTC) prints the same date and
// time as the browser. Without it a 21:00 event rendered as "Dom 15 · 00:00".
const AR_TIMEZONE = 'America/Argentina/Buenos_Aires';

const toBannerDateTime = (isoDate: string) => DateTime.fromISO(isoDate).setZone(AR_TIMEZONE).setLocale('es');

const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1).replace(/\.$/, '');

const dayLabel = (dt: DateTime) => `${cap(dt.toFormat('ccc'))} ${dt.day}`;

const monthLabel = (dt: DateTime) => cap(dt.toFormat('LLL'));

// Short, single-line banner date: "Mié 16 Jun · 23:00 hs"
export const formatBannerDate = (isoDate: string): string => {
  const dt = toBannerDateTime(isoDate);
  return `${dayLabel(dt)} ${monthLabel(dt)} · ${dt.toFormat('HH:mm')} hs`;
};

// Same style for a group of events (a festival's nights):
//   two days        → "Vie 13 y Sáb 14 Nov · 21:00 hs"
//   three or more   → "Vie 13 al Dom 15 Nov"
// The time is only shown when every event starts at the same hour.
export const formatBannerDateRange = (isoDates: string[]): string => {
  if (isoDates.length === 0) {
    return '';
  }
  const dates = isoDates.map(toBannerDateTime).sort((a, b) => a.toMillis() - b.toMillis());
  const first = dates[0];
  const last = dates[dates.length - 1];
  const times = new Set(dates.map((dt) => dt.toFormat('HH:mm')));
  const timeSuffix = times.size === 1 ? ` · ${first.toFormat('HH:mm')} hs` : '';
  const dayCount = new Set(dates.map((dt) => dt.toISODate())).size;

  if (dayCount === 1) {
    return `${dayLabel(first)} ${monthLabel(first)}${timeSuffix}`;
  }

  const joiner = dayCount === 2 ? 'y' : 'al';
  const start = first.hasSame(last, 'month') ? dayLabel(first) : `${dayLabel(first)} ${monthLabel(first)}`;
  return `${start} ${joiner} ${dayLabel(last)} ${monthLabel(last)}${timeSuffix}`;
};
